<template>
    <div class="card category-card">
        <div class="category-card__info">
            <div class="category-card_title">
                {{ title }}
            </div>
            <ul class="category-card_list">
                <li v-for="item in items">
                    {{ item }}
                </li>
            </ul>
            <div class="category-card__all">
                <span @click="$router.push('categories')">Смотреть все</span>
                  <chevron-right-icon size="1x" class="custom-class"></chevron-right-icon>
            </div>
        </div>
        <div class="category-card__img">
            <img :src="require('@/assets/img/cat.svg')" alt="">
        </div>
    </div>
</template>

<script>
    import { ChevronRightIcon } from 'vue-feather-icons'

    export default {
        name: "CategoryCard",
        props: {
            title: {
                type: String,
                default: ''
            },
            items: {
                type: [Array],
                default: () => {}
            }
        },
        components: {
            ChevronRightIcon
        }
    };
</script>

<style scoped lang="scss">
    .category-card {
        display: flex;
        /*justify-content: space-between;*/
        border-radius: 5px;
        /*height: 216px;*/
        width: 384px;
        padding: 16px;
        box-shadow: 0 2px 15px rgba(0, 0, 0, 0.05);
        margin-bottom: 32px;

        &__info {
            display: flex;
            flex-direction: column;
            width: 55%;
        }
        &_title {
            color: #3F4450;
            font-size: 18px;
            margin-bottom: 16px;
        }
        &_list {
            list-style: none;
            li {
                display: flex;
                align-items: center;
                font-size: 14px;

                color: #686F83;
                margin-bottom: 16px;
                cursor: pointer;
                &:before {
                    content: "";
                    display: inline-block;
                    background-color: #3FB0AB;
                    width: 8px;
                    height: 1px;
                    margin-right: 8px;
                }
            }
        }
        &__all {
            display: flex;
            align-items: center;
            color: #3FB0AB;
            font-size: 14px;
            margin-top: auto;
            cursor: pointer;
            svg {
                margin-left: 7px;
            }
        }
    }
</style>
